/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { IStackStyles } from '@fluentui/react/lib/Stack';
import { ITheme } from '@fluentui/react/lib/Styling';

export const getMenuEntryStyles = (theme: ITheme): Partial<IStackStyles> => {
    return {
        root: {
            selectors: {
                '&:hover': { background: theme.palette.neutralQuaternary },
                '&:focus': { outlineColor: theme.palette.black },
            },
        },
    };
};
